<div class="p-3">
  <header class="fs-24 fw-600 ms-2 pt-2">Search</header>
  <form class="form form-inline mb-4 ms-2" role="search" (submit)="search()">
    <div class="form-group col-md-4 col-sm-12 p-0 d-flex">
      <input [(ngModel)]="term" name="searchTerm" class="form-control rounded-0 col-md-6 col-sm-12 " type="text"
        id="search_input" placeholder="Type and click on search" autocomplete="off" />
      <button type="submit" class="btn btn-primary btn-sm p-1 mx-2  rounded-0" id="search_btn">Search</button>
      <button class="btn btn-primary  " (click)="location.back()">Back</button>
    </div>


  </form>

  <div class="d-flex align-items-center ps-2 pb-2 ">
    <label class="me-4 fw-500">Display Results for:</label>

    <label class="me-2" tappable [ngClass]="{'active-card':show.doctor}">
      <input type="checkbox" class="d-none" name="doctor" [(ngModel)]="show.doctor">Business
    </label>
    <!-- <label class="me-2" tappable [ngClass]="{'active-card':show.partner}">
    <input type="checkbox" class="d-none" name="partner" [(ngModel)]="show.partner">Partner
  </label> -->
    <label class="me-2" tappable [ngClass]="{'active-card':show.patient}">
      <input type="checkbox" class="d-none" name="patient" [(ngModel)]="show.patient">Customer
    </label>
    <label class="me-2" tappable [ngClass]="{'active-card':show.contract}">
      <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.contract">Contract
    </label>
    <!-- <label class="me-2" tappable [ngClass]="{'active-card':show.payments}">
    <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.payments">Payment Processing
  </label> -->
    <!-- <label class="me-2" tappable [ngClass]="{'active-card':show.ar}">
    <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.ar">Crdee Bill
  </label> -->
    <label class="me-2" tappable [ngClass]="{'active-card':show.proposal}">
      <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.proposal">Proposal Request
    </label>

    <label class="me-2" tappable [ngClass]="{'active-card':show.training}">
      <input type="checkbox" class="d-none" name="training" [(ngModel)]="show.training">Trainings
    </label>

    <label class="me-2" tappable [ngClass]="{'active-card':show.settled_accounts}">
      <input type="checkbox" class="d-none" name="training" [(ngModel)]="show.settled_accounts">Paid In Full Accounts
    </label>
    <!-- <label class="me-2" tappable [ngClass]="{'active-card':show.pa_leads}">
    <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.pa_leads">Pre-approval Leads
  </label> -->
    <label class="me-2" tappable [ngClass]="{'active-card':show.assignments}">
      <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.assignments">Followup Assignments
    </label>
    <label class="me-2" tappable [ngClass]="{'active-card':show.callback_assignments}">
      <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.callback_assignments">Callback Assignments
    </label>
  </div>

  <div class="card card-default p-2"
    *ngIf="!emptyData && show && !show.doctor && !show.partner && !show.patient && !show.contract && !show.payments && !show.ar && !show.proposal && !show.training && !show.settled_accounts && !show.assignments && !show.callback_assignments">
    Please select atleast one filter to see results;
  </div>

  <div class="card card-default" *ngIf="emptyData">
    <div class="card-header">Search - "{{term?term:''}}"</div>
    <div class="card-body">
      <p class="text-center">No Result Found!</p>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.doctor) && (results && results.doctors && results.doctors.length)">
      <div class="card card-default p-2">
        <h3>Businesses</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-2" *ngFor="let doctor of results.doctors; let i=index"
            [routerLink]="'/app/business/details/'+_shared.encodeId(doctor.doctor_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-primary">
                {{doctor.doctor_name ? doctor.doctor_name : 'N/A'}}
              </h3>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email:</span>
                  <span [innerHTML]="doctor.doctor_email | highlight:searched_string"></span><i *ngIf="doctor?.hash_doctor_email" class="fa fa-eye" style="color: blue;" (click)="$event.preventDefault(); $event.stopPropagation(); storeInfoAction(doctor.hash_doctor_email, 'doctor_email', i)" tappable tooltip="View Info"></i>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone:</span>
                  {{doctor.doctor_mobile}}<i *ngIf="doctor?.hash_doctor_mobile" class="fa fa-eye" style="color: blue;" (click)="$event.preventDefault(); $event.stopPropagation(); storeInfoAction(doctor.hash_doctor_mobile, 'doctor_mobile', i)" tappable tooltip="View Info"></i></div>
                <div class="col-6 text-label">
                  <span class="text-muted">Business Name:</span>
                  <span [innerHTML]="doctor.practice_name | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label">
                  <span class="text-muted">Business Email:</span>
                  <span [innerHTML]="doctor.practice_email | highlight:searched_string"></span><i *ngIf="doctor?.hash_practice_email" class="fa fa-eye" style="color: blue;" (click)="$event.preventDefault(); $event.stopPropagation(); storeInfoAction(doctor.hash_practice_email, 'practice_email', i)" tappable tooltip="View Info"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align:right">
          <a (click)="viewAllDetails('doctor')"><small>View All ({{totalRowsOfEach?.doctor_list}})</small></a>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.contract) && (results && results.contracts && results.contracts.length)">
      <div class="card card-default p-2">
        <h3>Contracts</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-2" *ngFor="let contract of results.contracts"
            [routerLink]="'/app/contracts/details/'+_shared.encodeId(contract.contract_id)" id="contract_details">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-primary">
                <span [innerHTML]="contract.contract_code | highlight:searched_string" class="h3 text-bold"></span>
                <span *ngIf="contract.pf_status<3" class="badge bg-success float-right ms-1">Active</span>
                <span *ngIf="contract.pf_status==3" class="badge bg-warning float-right ms-1">Overdue</span>
                <span *ngIf="contract.pf_status==4" class="badge bg-success float-right ms-1">Completed</span>
                <span *ngIf="contract.pf_status==5" class="badge bg-danger float-right ms-1">Canceled</span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Business Owner Name:</span>
                  {{contract.doctor_title}} <span
                    [innerHTML]="(contract.doctor_name || 'N/A') | highlight:searched_string:'capital'"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Business Owner Email:</span>
                  <span [innerHTML]="(contract.doctor_email || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Customer Name:</span>
                  <span [innerHTML]="(contract.patient_name || 'N/A') | highlight:searched_string:'capital'"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Customer Email:</span>
                  <span [innerHTML]="(contract.patient_email || 'N/A') | highlight:searched_string"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div style="text-align:right">
          <a (click)="viewAllDetails('contract')"><small>View All ({{totalRowsOfEach?.pf_payments}})</small></a>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.patient) &&(results && results.patients && results.patients.length)">
      <div class="card card-default p-2">
        <h3>Customers</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-2" *ngFor="let patient of results.patients"
            [routerLink]="'/app/customers/profile/'+_shared.encodeId(patient.patient_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-primary">{{patient.patient_title}}
                <span class="h3 text-bold"
                  [innerHTML]="(patient.patient_name || 'N/A') | highlight:searched_string:'capital'"></span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Email:</span>
                  <span [innerHTML]="(patient.patient_email || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone:</span>
                  {{patient.patient_mobile || 'N/A'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align:right">
          <a (click)="viewAllDetails('patient')"><small>View All ({{totalRowsOfEach?.patient_list}})</small></a>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.payments) &&(results && results.payments && results.payments.length)">
      <div class="card card-default p-2">
        <h3>Payments Processed</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-2" *ngFor="let payment of results.payments"
            [routerLink]="'/app/payment-processing/'+payment.id">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-primary">
                <span class="h3 text-bold"
                  [innerHTML]="payment.patient_name | highlight:searched_string:'capital'"></span>
                <span *ngIf="payment.status==1" class="badge bg-warning float-right">Pending</span>
                <span *ngIf="payment.status==2" class="badge bg-success float-right">Success</span>
                <span *ngIf="payment.status==3" class="badge bg-danger float-right">Failed</span>
                <span *ngIf="payment.status==4" class="badge bg-info float-right">Refunded</span>
                <span *ngIf="payment.status==5" class="badge bg-danger float-right">Declined</span>
              </h3>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email:</span>
                  <span [innerHTML]="(payment.patient_email || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label">
                  <span class="text-muted">Phone:</span>
                  {{payment.patient_mobile ? (payment.patient_mobile): 'N/A'}}
                </div>
                <div class="col-12 text-label">
                  <span class="text-muted">Payment ID:</span>
                  <span 
                    [innerHTML]="(payment.payment_process_code || 'N/A') | highlight:searched_string"></span>
                
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align:right">
          <a (click)="viewAllDetails('payments')"><small>View All ({{totalRowsOfEach?.payments_list}})</small></a>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-12" *ngIf="(show && show.ar) &&(results && results.ar && results.ar.length)">
      <ng-container *ngIf="results.ar as proposal_ar">
        <ng-container
          *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal_ar, heading: 'Credee Bill', link: '/app/accounts-receivable/details/'}}"></ng-container>
      </ng-container>
      <div class="card card-default p-2">
        <h3>Credee Bill</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-2" *ngFor="let payment of results.ar"
            [routerLink]="'/app/accounts-receivable/details/'+payment.split_req_id">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-primary">
                <span class="h3 text-bold"
                  [innerHTML]="payment.patient_name | highlight:searched_string:'capital'"></span>
                <span *ngIf="payment.status==1" class="badge bg-warning float-right">Pending</span>
                <span *ngIf="payment.status==2" class="badge bg-success float-right">Success</span>
                <span *ngIf="payment.status==3" class="badge bg-danger float-right">Failed</span>
                <span *ngIf="payment.status==4" class="badge bg-info float-right">Refunded</span>
                <span *ngIf="payment.status==5" class="badge bg-danger float-right">Declined</span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Email:</span>
                  <span [innerHTML]="(payment.patient_email || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone:</span>
                  {{payment.patient_mobile ? (payment.patient_mobile): 'N/A'}}</div>
                <div class="col-12 text-label">
                  <span class="text-muted">Payment ID:</span>
                  <span *ngIf="payment.payment_process_code"
                    [innerHTML]="payment.payment_process_code | highlight:searched_string"></span>
                  <span *ngIf="!payment.payment_process_code">N/A</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align:right">
        <a (click)="viewAllDetails('ar')"><small>View All ({{totalRowsOfEach?.ar_list}})</small></a>
      </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.proposal) &&(results && results.proposal && results.proposal.length)">
      <ng-container *ngIf="results.proposal as proposal">
        <ng-container
          *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal, heading: 'Proposal Request', link: '/app/debt-recovery/details/',count:totalRowsOfEach?.proposal_list,search_type:'proposal',encode:true}}"></ng-container>
      </ng-container>
    </div>

    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.settled_accounts) &&(results && results.settled_accounts && results.settled_accounts.length)">
      <ng-container *ngIf="results.settled_accounts as proposal">
        <ng-container
          *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal, heading: 'Paid In Full Accounts', link: '/app/debt-recovery/payment-details/',count:totalRowsOfEach?.settled_accounts,search_type:'settled_accounts',encode:true}}"></ng-container>
      </ng-container>
    </div>

    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.pa_leads) &&(results && results.pa_leads && results.pa_leads.length)">
      <div class="card card-default p-2">
        <h3>Pre-approval Leads</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-2" *ngFor="let lead of results.pa_leads"
            [routerLink]="'/app/patients/customers-leads/details/'+lead.application_id">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-primary">
                <span [innerHTML]="lead.application_id | highlight:searched_string" class="h3 text-bold"></span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Business Owner Name:</span>
                  <span
                    [innerHTML]="(lead.doctor_first_name + lead.doctor_last_name) | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Business Owner Email:</span>
                  <span [innerHTML]="lead.doctor_email | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Customer Name:</span>
                  <span [innerHTML]="lead.full_cust_name | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Customer Email:</span>
                  <span [innerHTML]="lead.customer_email | highlight:searched_string"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align:right">
          <a (click)="viewAllDetails('pa_leads')"><small>View All ({{totalRowsOfEach?.pa_leads}})</small></a>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.training) && (results && results.training && results.training.length)">
      <div class="card card-default p-2">
        <h3>Trainings</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-2" *ngFor="let trianing of results.training"
            [routerLink]="'/app/training/details/'+_shared.encodeId(trianing.training_event_time_slot_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <span class="d-flex">
                <h3 class="my-1 text-primary" [innerHTML]="trianing.training_doctor_partner_name | highlight:searched_string:'capital'">
                  <!-- <span [innerHTML]="trianing.doctor_name | highlight:searched_string:'capital'"
                ></span> -->

                </h3>
                <span class="rounded text-white h-25 float-right p-0 ps-2 pe-2 mt-2 ms-2 text-center"
                  [ngStyle]="{'background-color':trianing?.training_status_color_code || ''}">{{trianing?.training_status_name
                  || ''}}</span>
              </span>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email: </span>
                  <span [innerHTML]="(trianing.training_doctor_partner_email || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone: </span>
                  {{trianing.training_doctor_partner_phone ? trianing.training_doctor_partner_phone : 'N/A'}}
                </div>
                <!-- <div class="col-6 text-label">
                  <span class="text-muted">Type of Training: </span>
                  <span [innerHTML]="trianing.type_name | highlight:searched_string"></span>
                </div> -->
                <div class="col-6 text-label">
                  <span class="text-muted">Business Name:</span>
                  <span [innerHTML]="(trianing.training_practice_name || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label">
                  <span class="text-muted">Business Email:</span>
                  <span [innerHTML]="(trianing.practice_email || 'N/A') | highlight:searched_string"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align:right">
          <a (click)="viewAllDetails('training')"><small>View All ({{totalRowsOfEach?.training_list}})</small></a>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.assignments) && (results && results.assignments && results.assignments.length)">
      <div class="card card-default p-2">
        <h3>Followup Assignments</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-2" *ngFor="let assignment of results.assignments"
            [routerLink]="'/app/assignments/my-assignments/'+_shared.encodeId(assignment.req_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <span class="d-flex">
                <h3 class="my-1 text-primary">
                  {{(assignment.account_id || assignment.patient_name) ? (assignment.patient_name || 'N/A') : assignment.doctor_name ? assignment.doctor_name : assignment.wp_name ? assignment.wp_name : assignment.name ? assignment.name : 'N/A'}}
                </h3>
                <span *ngIf="assignment.status == 0"
                  class="badge bg-warning"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Pending</span>
                <span *ngIf="assignment.status == 1"
                  class="badge bg-dark"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Closed</span>
                <span *ngIf="assignment.status == 2"
                  class="badge bg-primary"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Re-Opened</span>
                <span *ngIf="assignment.status == 3"
                  class="badge bg-info"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Follow up</span>
              </span>
              <div class="row" *ngIf="assignment.account_id || assignment.patient_name; else businessInfo">
                <div class="col-6 text-label">
                  <span class="text-muted">Account ID: </span>
                  <span [innerHTML]="assignment.account_id || 'N.A' | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone: </span>
                  {{assignment.patient_mobile || 'N.A'}}</div>
                <div class="col-6 text-label">
                  <span class="text-muted">Email: </span>
                  <span [innerHTML]="assignment.patient_email || 'N.A' | highlight:searched_string"></span>
                </div>
              </div>
              <ng-template #businessInfo>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email: </span>
                  <span [innerHTML]="assignment.doctor_email || assignment.patient_email || assignment.wp_email || assignment.email | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone: </span>
                  {{assignment.doctor_mobile || assignment.patient_mobile || assignment.wp_phone || assignment.mobile}}</div>
                <div class="col-6 text-label">
                  <span class="text-muted">Business Name: </span>
                  <span [innerHTML]="assignment.practice_name || 'N.A' | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label">
                  <span class="text-muted">Business Email: </span>
                  <span [innerHTML]="assignment.practice_email || 'N.A' | highlight:searched_string"></span>
                </div>
              </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div style="text-align:right">
          <a (click)="viewAllDetails('assignments')"><small>View All ({{totalRowsOfEach?.assignments}})</small></a>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-12"
      *ngIf="(show && show.callback_assignments) && (results && results.callback_assignments && results.callback_assignments.length)">
      <div class="card card-default p-2">
        <h3>Callback Assignments</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-2" *ngFor="let assignment of results.callback_assignments"
            [routerLink]="'/app/assignments/my-assignments/'+_shared.encodeId(assignment.req_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <span class="d-flex">
                <h3 class="my-1 text-primary">
                  {{assignment.doctor_name ? assignment.doctor_name : assignment.name ? assignment.name : assignment.patient_name ? assignment.patient_name : 'N/A'}}
                </h3>
                <span *ngIf="assignment.status == 0"
                  class="badge bg-warning"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Pending</span>
                <span *ngIf="assignment.status == 1"
                  class="badge bg-dark"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Closed</span>
                <span *ngIf="assignment.status == 2"
                  class="badge bg-primary"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Re-Opened</span>
                <span *ngIf="assignment.status == 3"
                  class="badge bg-info"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Follow up</span>
              </span>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email: </span>
                  <span [innerHTML]="assignment.doctor_email || assignment.email || assignment.patient_email | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone: </span>
                  {{assignment.doctor_mobile || assignment.mobile || assignment.patient_mobile}}</div>
                <div class="col-6 text-label">
                  <span class="text-muted">Request: </span>
                  <span [innerHTML]="assignment.action_value || 'N.A.' | highlight:searched_string"></span>
                </div>
                <!-- <div class="col-6 text-label">
                  <span class="text-muted">Business Email:</span>
                  <span [innerHTML]="assignment.practice_email | highlight:searched_string"></span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div style="text-align:right">
          <a (click)="viewAllDetails('callback_assignments')"><small>View All ({{totalRowsOfEach?.callback_assignments}})</small></a>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #proposals_listing let-data="data">
  <div class="card card-default p-2">
    <h3>{{data.heading}}</h3>
    <div class="p-2 row">
      <div class="col-md-12 mb-2" *ngFor="let payment of data.list" [routerLink]="data.link + (data.encode ? _shared.encodeId(payment.split_req_id) : payment.split_req_id)" [queryParams]="{ is_deleted: payment.is_deleted }">
        <div class="col-12 py-2 border rounded clickable-item px-2 ">
          <h3 class="my-1 text-primary">
            <span class="h3 text-bold" [innerHTML]="payment.debt_type == 1 ? payment.patient_name : payment.business_name | highlight:searched_string:'capital'"></span>
            <span *ngIf="payment.amount_deducted> 0 && payment.stripe_status != 1" class="badge bg-success float-right fw-600 ms-1">Settled-Paid In Full</span>
            <span *ngIf="payment.amount_deducted> 0 && payment.stripe_status == 1" class="badge bg-primary float-right fw-600 ms-1">Refunded</span>
            <span *ngIf="payment.webhook_status == 0" class="badge bg-warning float-right fw-600 ms-1">Initiated</span>
            <span *ngIf="payment.webhook_status == 2 " class="badge bg-danger float-right fw-600 ms-1">Failed</span>

          </h3>
          <div class="row">
             <div class="col-6 text-label"><span class="text-muted">Business Owner Name:</span>
                <span [innerHTML]="(payment.doctor_name || 'N/A') | highlight:searched_string"></span>
              </div>
              <div class="col-6 text-label"><span class="text-muted">Business Owner Email:</span>
                <span [innerHTML]="(payment.doctor_email || 'N/A') | highlight:searched_string"></span>
              </div>
              <div class="col-6 text-label"><span class="text-muted">Customer Email:</span>
                {{payment.patient_email ? (payment.patient_email): 'N/A'}}
              </div>
              <!-- <div class="col-6 text-label"><span class="text-muted">Customer Phone:</span>
                {{payment.patient_mobile ? (payment.patient_mobile): 'N/A'}}
              </div> -->
              <div class="col-6 text-label"><span class="text-muted">Account ID:</span>
                {{payment.contract_code ? payment.contract_code :  payment.contract_patient_token.toUpperCase() }}
              </div>
           </div>
        </div>
      </div>
      <div style="text-align:right">
        <a (click)="viewAllDetails(data.search_type)"><small>View All ({{data?.count}})</small></a>
      </div>
    </div>
  </div>
</ng-template>